import { render, staticRenderFns } from "./ModalHistorialesEstadosAcademicos.vue?vue&type=template&id=7230687c"
import script from "./ModalHistorialesEstadosAcademicos.vue?vue&type=script&lang=js"
export * from "./ModalHistorialesEstadosAcademicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports